<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/v3I8dl/tc-custom/9781497655065.jpg?1704761579409" alt="This image is the cover for the book Collar"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Collar
      </h1>
      <p class="bookDescription body article font2">
        <b>Compelling tales of the clergy from the renowned author. “The work of Frank O’Connor lies at the very heart of the modern story in Ireland” (<i>The Washington Post</i>).</b><br/>  <br/> Over the course of his long and distinguished career, Frank O’Connor wrote many stories about priests. Some of his most iconic characters are men of the cloth, and few writers have portrayed the unique demands of the priesthood with as much empathy, honesty, and wit. This collection, edited and introduced by his widow, Harriet O’Donovan Sheehy, brings together the best of O’Connor’s short fiction on the subject.<br/>  <br/> From “An Act of Charity,” the ironically titled tale of church efforts to cover up a curate’s suicide, to “The Sentry,” an exquisite blend of drama and satire sparked by the British army’s invasion of a priest’s onion patch, these sixteen stories capture the full range of pressures visited on the Irish clergy. “Peasants” is a lesson in what happens when a man of God places law and order above compassion, while “Achilles’ Heel” reveals that even a bishop can be rendered powerless by his housekeeper. “The Frying-pan” and “The Wreath” are sad and lovely portraits of priests caught between their vows of celibacy and their natural desire for human connection.<br/>  <br/> In the rituals and contradictions of the priesthood, Frank O’Connor found one of his greatest motifs. <i>The Collar </i>showcases an artist at the peak of his powers and shines a brilliant light on a fascinating world too often hidden in shadow and sentiment.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frank O'Connor
      </h2>
      
      <p class="authorDescription body article">Frank O&rsquo;Connor (1903&ndash;1966) was born in Cork, Ireland, and fought for the Irish Republican Army in the war for independence. He was a prolific author of short stories, plays, literary criticism, memoir, and poetry, and the managing director of the Abbey Theatre in Dublin. In addition to being a renowned writer whom W. B. Yeats famously described as &ldquo;doing for Ireland what Chekhov did for Russia,&rdquo; O&rsquo;Connor was also a highly regarded teacher and translator of Irish literature. The world&rsquo;s richest prize for short fiction is named in his honor.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b9896062